import store from "@src/reducers/store";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import { sendSnackbarNotificationWhenMaximumAmountOfMonitoringNodesIsExceeded } from "./check-if-maximum-amount-of-monitoring-nodes-is-exceeded.ts";

interface UnitTypes {
  code: number;
  display_name: string;
  description: string;
}

export const saveNodeDataInPanel = (
  nodeId: string,
  name: string,
  dataAcquisitionType: string,
  pollingIntervalTime: number,
  unit: UnitTypes,
) => {
  const node = getMachineStructureNodeset().getFlatMap().get(nodeId);
  const nodeManager = getNodeManager();

  nodeManager
    .getSaveNodeDataInPanelHandler()
    .saveNodeDataInPanel(
      node,
      name,
      dataAcquisitionType,
      pollingIntervalTime,
      unit,
    );

  const maximumAmountOfMonitoringNodes =
    store.getState().yourSlice.maximum_number_of_monitored_items;

  sendSnackbarNotificationWhenMaximumAmountOfMonitoringNodesIsExceeded(
    getMachineStructureNodeset(),
    maximumAmountOfMonitoringNodes,
  );
};
